import createActions from 'utils/redux/createActions'

export default createActions([
	'ATTACHMENT_OPEN'
  , 'ATTACHMENT_CLOSE'
])



// WEBPACK FOOTER //
// ./src/actions/attachmentOverlayActions.js